var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1038 19.4877C6.95459 19.9065 0.141263 9.53309 1.08788 4.47175C1.95642 2.9793 3.06968 1.87391 4.55963 1L7.80015 5.45123L6.15676 8.30534C6.15676 8.30534 6.61055 10.2107 8.31847 11.9186C10.1111 13.7112 12.1107 14.2593 12.1107 14.2593L14.9648 12.6159L19.5756 16.0159C18.7178 17.5485 17.6364 18.6299 16.1038 19.4877Z",
    stroke: "#26CD9F",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone2.2a2cc35c455fa42a2f476fc171d698d8.svg";
export { ForwardRef as ReactComponent };